export const APP_NAME = 'bidzbase';
export const LOGO_SRC = '/bidzbase-logo-no-bg.png';
export const LOGO_SRC_DARK = '/bidzbase-darkmode-nobg-logo.png';
export const WEBSITE_URL = 'https://bidzbase.com';

export const getLogoSrc = (mode = 'light', variant = 'theme') => {
	if (variant === 'onDark') {
		return LOGO_SRC_DARK;
	}
	return mode === 'dark' ? LOGO_SRC_DARK : LOGO_SRC;
};
